// import React from "react";
// import SectionHeading from "../NewHome/SectionHeading";

// const OurValues = () => {
//   return (
//     <div>
//       <SectionHeading title={`Our Values`} />
//     </div>
//   );
// };

// export default OurValues;
import React from "react";
import img1 from "../../../Assets/Images/about/our_values_1.jpeg";
import img2 from "../../../Assets/Images/about/our_values_2.jpeg";
import img3 from "../../../Assets/Images/about/our_values_3.jpeg";
import img4 from "../../../Assets/Images/about/our_values_4.jpeg";
import AboutHeadings from "./AboutHeadings";
const OurValues = () => {
  const values = [
    {
      title: "Humanity First",
      desc: "Compassion without bias.",
    },
    {
      title: "Integrity",
      desc: "Every effort is honest and transparent.",
    },
    {
      title: "Sustainability",
      desc: "Change that lasts for generations.",
    },
    {
      title: "Collaboration",
      desc: "Because together, we achieve more.",
    },
  ];

  const images = [img1, img2, img3, img4];

  return (
    <section className="w-full mb-8 py-8 sm:py-12 px-4 md:px-[5rem]">
      <div className="w-full mx-auto flex flex-col items-start justify-start lg:flex-row gap-x-12 gap-y-16 lg:items-center">
        {/* Left Section */}
        <div
          data-aos="fade-right"
          className="space-y-6 grow w-full lg:max-w-[50%]"
        >
          <AboutHeadings title={"Our Values"} textAlign="left" />
          <div className="grid grid-cols-2   gap-6">
            {values.map((value, idx) => (
              <div
                key={idx}
                className="group hover:shadow-sm rounded-md  hover:-translate-y-2 transition-all duration-500"
              >
                {/* Index Number */}
                <div className="flex gap-2">
                  <h1 className="text-3xl lg:text-5xl font-extrabold text-primaryColor transition-colors">
                    {idx + 1}
                  </h1>
                  <span className="flex self-end mb-3 lg:mb-4 w-2 h-2 rounded-full bg-primaryColor font-bold"></span>
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-800 mt-2 group-hover:text-primaryColor transition-colors">
                  {value.title}
                </h3>

                {/* Subtitle */}
                <p className="text-gray-600 mt-1">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Right Section (Masonry Grid) */}
        <div
          //   data-aos="fade-left"
          className="grid grid-cols-10 grid-rows-10 gap-4 content-end max-w-full lg:max-w-[50%]"
        >
          {/* Column 1 */}
          <div className="col-span-5 row-span-10 flex flex-col gap-4 translate-y-6">
            <div className="relative overflow-hidden rounded-md shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 group">
              <img
                src={images[0]}
                alt="value-0"
                className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-500"></div>
            </div>

            <div className="relative overflow-hidden rounded-md shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 group">
              <img
                src={images[1]}
                alt="value-1"
                className="w-full h-60 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-500"></div>
            </div>
          </div>

          {/* Column 2 */}
          <div className="col-span-5 row-span-10 flex flex-col gap-4 -translate-y-6">
            <div className="relative overflow-hidden rounded-md shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 group">
              <img
                src={images[2]}
                alt="value-2"
                className="w-full h-60 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500"></div>
            </div>

            <div className="relative overflow-hidden rounded-md shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 group">
              <img
                src={images[3]}
                alt="value-3"
                className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurValues;
